export const CDN = 'https://svenn-eeh.cdn.modulify.website'

const photo = (name: string): string => `${CDN}/images/photo/${name}.webp`
const ui = (name: string): string => `${CDN}/images/ui/${name}.webp`

export const PHOTO = {
    beamCarrySnow: photo('beam-carry-snow'),
    benedikte: photo('benedikte-tyskeberg'),
    carpenterArmsCrossedWide: photo('carpenter-arms-crossed-wide'),
    carpenterMitreSaw: photo('carpenter-mitre-saw'),
    carpenterNeonFrame: photo('carpenter-neon-frame'),
    claddingRouter: photo('cladding-router'),
    craftsmanArmsCrossed: photo('craftsman-arms-crossed'),
    craftsmanBrickWall: photo('craftsman-brick-wall'),
    craftsmanInsulation: photo('craftsman-insulation'),
    crewPhoneIndoor: photo('crew-phone-indoor'),
    crewThreeLookingUp: photo('crew-three-looking-up'),
    crewThreeStreet: photo('crew-three-street'),
    crewTwoTimberFrame: photo('crew-two-timber-frame'),
    customerSnowSquare: photo('customer-snow-square'),
    customerSnowWide: photo('customer-snow-wide'),
    fenceDrilling: photo('fence-drilling'),
    findingCrackedTile: photo('finding-cracked-tile'),
    findingOutlet: photo('finding-outlet'),
    findingWaterDamage: photo('finding-water-damage'),
    georg: photo('georg-hh-handverk'),
    georgOrangeLevel: photo('georg-orange-level'),
    glovesPhoneApp: photo('gloves-phone-app'),
    hivisBasement: photo('hivis-basement'),
    hmsInspection: photo('hms-inspection'),
    insulationPhoneWide: photo('insulation-phone-wide'),
    rooferNailgun: photo('roofer-nailgun'),
    roofersScaffold: photo('roofers-scaffold'),
    scaffoldSnowCrew: photo('scaffold-snow-crew'),
    scanningTimberFrame: photo('scanning-timber-frame'),
    sentraltGodkjent: photo('sentralt-godkjent-measuring'),
    svennTeam: photo('svenn-team-office'),
    timberFrameSnow: photo('timber-frame-snow'),
    whiteRoomCarpenter: photo('white-room-carpenter')
} as const

export const UI = {
    absenceCalendar: ui('absence-calendar'),
    appHomeDark: ui('app-home-dark'),
    befaringReportPhone: ui('befaring-report-phone'),
    byggemaler: ui('byggemaler'),
    checklistDocument: ui('checklist-document'),
    checklistHeight: ui('checklist-height'),
    checklistWebPhone: ui('checklist-web-phone'),
    checklistsPhone: ui('checklists-phone'),
    desktopFloorplan3d: ui('desktop-floorplan-3d'),
    digitalSignature: ui('digital-signature'),
    documentationFiles: ui('documentation-files'),
    floorplanEditor: ui('floorplan-editor'),
    handScanningHallway: ui('hand-scanning-hallway'),
    hmsChat: ui('hms-chat'),
    integrationsGrid: ui('integrations-grid'),
    lockscreenNotification: ui('lockscreen-notification'),
    model3dColor: ui('model-3d-color'),
    model3dGrey: ui('model-3d-grey'),
    photoAnnotation: ui('photo-annotation'),
    plannerDrag: ui('planner-drag'),
    prislister: ui('prislister'),
    pristilbudPdf: ui('pristilbud-pdf'),
    projectChatPhone: ui('project-chat-phone'),
    projectOverviewPhone: ui('project-overview-phone'),
    registerHours: ui('register-hours'),
    roomScanned: ui('room-scanned'),
    scanArRoom: ui('scan-ar-room'),
    scanningPhoneWhite: ui('scanning-phone-white'),
    stampInPhone: ui('stamp-in-phone'),
    teamChat: ui('team-chat'),
    templateImport: ui('template-import'),
    tilbudEditor: ui('tilbud-editor'),
    tilbudsoversikt: ui('tilbudsoversikt'),
    timerSettings: ui('timer-settings'),
    timesheetGenerated: ui('timesheet-generated'),
    timesheetWebMobile: ui('timesheet-web-mobile'),
    voiceNote: ui('voice-note'),
    workplanMapPhone: ui('workplan-map-phone')
} as const

export const VIDEO = {
    befaringScan: `${CDN}/media/befaring-scan.mp4`
} as const

export const OG_DEFAULT = `${CDN}/images/og/og-default.jpg`
